import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const channelsRoutes: Routes = [
  {
    path: 'official-channels',
    loadComponent: () =>
      import('./channels.component').then((c) => c.ChannelsComponent),
    canActivate: [AuthGuard],
  },
];
